<template>
    <div class="modal-img-wrapper" v-if="visible">
        <div class="modal-img-div">
            <!-- <img
                class="modal-img"
                :src="baseUrl + 'storage/' + curImg.origPath"
                :alt="curImg.origPath"
            />-->
            <sponsored-img
                :src="baseUrl + 'storage/' + curImg.origPath"
                :alt="curImg.origPath"
                imgclass="modal-img"
                :sponsors="sponsors"
            ></sponsored-img>
        </div>
        <div
            class="modal-topright d-flex align-items-center flex-wrap"
            @click="visible = false"
        >
            <a
                :href="'/download/image/' + curImg.id"
                class="text-white d-flex align-items-center mr-3"
            >
                Download
                <i class="material-icons">
                    vertical_align_bottom
                </i>
            </a>
            <i class="material-icons text-light">close</i>
        </div>
        <div class="modal-right" @click="incIndex()">
            <i class="material-icons text-light uhe-nav-arrow"
                >keyboard_arrow_right</i
            >
        </div>
        <div class="modal-left" @click="decIndex()">
            <i class="material-icons text-light uhe-nav-arrow"
                >keyboard_arrow_left</i
            >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: []
        },
        sponsors: {
            type: Array,
            required: false,
            default: []
        }
    },
    data() {
        return {
            visible: false,
            curIndex: 0
        };
    },
    computed: {
        baseUrl() {
            return window.location.origin + "/";
        },
        curImg() {
            return this.images[this.curIndex];
        }
    },
    methods: {
        open(imgId = undefined) {
            if (imgId) this.curIndex = imgId;
            this.visible = true;
        },
        setData(images, curIndex) {
            this.images = images;
            this.curIndex = curIndex;
        },
        incIndex() {
            if (this.curIndex < this.images.length - 1) {
                this.curIndex++;
            } else {
                this.curIndex = 0;
            }
        },
        decIndex() {
            if (this.curIndex <= 0) {
                this.curIndex = this.images.length - 1;
            } else {
                this.curIndex--;
            }
        }
    }
};
</script>


<style scoped>
.modal-img-wrapper {
    position: fixed;
    z-index: 1050;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    background-color: rgba(0, 0, 0, 0.9);
}

.modal-img-div {
    display: flex;
    align-items: center;
}

.modal-topright {
    position: fixed;
    top: 0;
    right: 0;
    cursor: pointer;
    margin: 2rem;
    z-index: 1055;
    user-select: none;
}

.modal-right {
    height: 100vh;
    width: 50vw;
    right: 0;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 1.5rem;
    user-select: none;
}

.modal-left {
    height: 100vh;
    width: 50vw;
    left: 0;
    position: fixed;
    display: flex;
    align-items: center;
    padding-left: 1.5rem;
    user-select: none;
}

.uhe-nav-arrow {
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
}
</style>

